import React from 'react';
import MultiStepForm from '../Form/MultiStepForm';
import { useCorporateClient } from './CorporateGate';

export default function CorporatePage() {
  const { corporateClient, session } = useCorporateClient();

  return (
    <div>
      {/* Company banner */}
      <div className="w-full bg-charcoal text-white text-center py-2 px-4">
        <p className="text-xs font-bold uppercase tracking-widest text-blush-200">
          {corporateClient.name} — Corporate Ordering
        </p>
      </div>
      <MultiStepForm corporateClient={corporateClient} session={session} />
    </div>
  );
}
